export const customFormValidators = {
	minValue: {
		rule: value => value >= 0,
		message: 'VALIDATORJS.NUMERICMINVALUE',
	},
	numericMinValue: {
		rule: value => 1 / value > 0,
		message: 'VALIDATORJS.NUMERICMINVALUE',
	},
	notZero: {
		rule: value => value != 0,
		message: 'VALIDATORJS.NOTZEROVALUE',
	},
	invalidCharacter: {
		rule: value => value[value.length - 1] !== '.' && !value.toString().includes('e'),
		message: 'VALIDATORJS.INVALIDCHARACTER',
	},
	decimalLength: {
		rule: value => {
			const decimal = value.toString().split('.')[1];
			return decimal ? decimal.length <= 2 : true;
		},
		message: 'VALIDATORJS.MINIMUMLENGHT',
	},
	onePointDecimal: {
		rule: value => {
			const decimal = value.toString().split('.')[1];
			return decimal ? decimal.length <= 1 : true;
		},
		message: 'VALIDATORJS.ONEPOINTDECIMAL',
	},
};
